import cn from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { jacketShape } from '@bibliocommons/bc-prop-types';
import { Link } from '@bibliocommons/base-links';
import JacketCover from '@bibliocommons/shared-jacket-cover';
import { bindAll } from '@bibliocommons/utils-react';
import FormatIcon from '@bibliocommons/format-icon';

import './BibJacket.scss';

export class BibJacket extends React.PureComponent {
  constructor(props) {
    super(props);
    bindAll(this);
  }

  renderPlaceholder() {
    const { format, title } = this.props;
    const placeholder = this.props.placeholder || (format ? <FormatIcon format={format} /> : title?.charAt(0));

    return (
      <div className="placeholder-wrapper">
        <div className="placeholder">{placeholder}</div>
      </div>
    );
  }

  renderJacketCover() {
    const { format, cover } = this.props;

    return (
      <JacketCover
        size="large"
        format={format}
        renderDefault={this.renderPlaceholder}
        src={cover}
        loadingMode="eager"
      />
    );
  }

  render() {
    const { className, renderAsLink, metadataId, onClick } = this.props;

    const rootClassName = cn('cp-bib-jacket', className);

    return renderAsLink ? (
      <Link
        className={rootClassName}
        dataKey="bib-jacket-link"
        aria-hidden
        tabIndex="-1"
        href={`/v2/record/${metadataId}`}
        rel="noopener noreferrer"
        handleClick={onClick}
      >
        {this.renderJacketCover()}
      </Link>
    ) : (
      <div className={rootClassName} aria-hidden="true">
        {this.renderJacketCover()}
      </div>
    );
  }
}

BibJacket.defaultProps = {
  className: '',
  onClick: () => {}
};

BibJacket.propTypes = {
  className: PropTypes.string,
  renderAsLink: PropTypes.bool,
  placeholder: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  format: PropTypes.string,
  cover: jacketShape,
  metadataId: PropTypes.string.isRequired,
  onClick: PropTypes.func
};

export default BibJacket;
